import { InertiaLink, usePage } from "@inertiajs/inertia-react";
import React, { useState, useRef, useEffect } from "react";
import AppLayout from "@/Layouts/AppLayout";
import AdminLayout from "@/Layouts/AdminLayout";
import { useTitle } from "@/Utilities/Hooks";
import { generateDefaultDatespan } from "@/Utilities/Utilities";

import {
  Subheader,
  BlockButton,
  NumberLinkBlock,
  GidasFeed,
  ContentSlider,
  Video,
  Emma,
} from "@/Components/";
import { ErrorMessage, SuccessMessage } from "@/Components/Messages";
import { LoadingProvider, useLoading } from "@/Contexts/LoadingContext";
import { Budget } from "@/Pages/Admin/Budget";
import OrganizationLayout from "@/Layouts/OrganizationLayout";
import LayoutIcon from "@/Components/LayoutIcon";
import { House } from "@/Icons";

import { useAtom } from "jotai";
import {
  teamFilterAtom,
  questionFilterAtom,
  dateFilterAtom,
  locationFilterAtom,
  generalFilterAtom,
} from "@/Stores";
// import { endOfMonth, startOfMonth, subMonths } from "date-fns";

export default function General({ auth, flash, errors }) {
  useTitle("Welcome to Emma");

  // Oh god forgive me for what I'm about to do
  const user = auth?.user?.data || false;
  const orgId = usePage()?.props?.organization?.data?.id;
  const storageBucket =
    parseInt(localStorage.getItem("dashboardStorageBucket")) || 0;
  const [teamFilter, setTeamFilter] = useAtom(teamFilterAtom);
  const [questionFilter, setQuestionFilter] = useAtom(questionFilterAtom);
  const [dateFilter, setDateFilter] = useAtom(dateFilterAtom);
  const [locationFilter, setLocationFilter] = useAtom(locationFilterAtom);
  const [generalFilter, setGeneralFilter] = useAtom(generalFilterAtom);

  useEffect(() => {
    // reset all filters
    if (orgId !== storageBucket) {
      setTeamFilter([]);
      setQuestionFilter([]);
      setDateFilter(generateDefaultDatespan());
      setLocationFilter([]);
      setGeneralFilter({ source: [], format: ["ar5"], reports: "all" });
      localStorage.setItem("dashboardStorageBucket", orgId);
    }
  }, [orgId]);

  let [modal, setModal] = useState({
    open: false,
    title: "",
    content: "",
    class: "",
  });
  let [subscribed, setSubscribed] = useState(false); // TODO: get inital status if user is subscribed or not
  const isInitialMount = useRef(true);

  function openModal(t, d, c) {
    setModal({ open: true, title: t, content: d, class: c });
  }

  function closeModal() {
    setModal({ open: false, title: "", content: "", class: "" });
  }

  return (
    <div className="flex flex-col items-stretch pb-4">
      {flash.status && (
        <SuccessMessage className="mb-8">{flash.status}</SuccessMessage>
      )}

      {errors?.message && (
        <ErrorMessage className="mb-8">{errors?.message}</ErrorMessage>
      )}

      {/* <div className="flex flex-row flex-shrink-0 my-4">
        <div className="w-full sm:w-2/3">
          <h1 className="mb-4 header-1">Welcome to Emma, {user.firstname}</h1>
          <p className="text-gray-700">Save time, get a daily overview of your emissions and improve accuracy with the Emma workflow.</p>
        </div>
      </div> */}

      <div className="my-4 flex flex-shrink-0 flex-row flex-wrap gap-4 md:flex-nowrap">
        <BlockButton
          title="REPORTING"
          text="Report data"
          href={route("reporter.overview")}
          bgcolor="bg-primary hover:bg-primary-dark"
        />
        <BlockButton
          title="RESULTS"
          text="Go to results"
          href={route("reporter.dashboard")}
          bgcolor="bg-primary hover:bg-primary-dark"
        //   bgcolor="bg-blue-dark hover:bg-[#1E293B]"
        />
      </div>

      <LoadingProvider>
        <Budget />
      </LoadingProvider>

      <Subheader id="tutorials" className="mt-10">
        TUTORIALS
      </Subheader>
      <div className="relative flex w-full flex-col items-center justify-center">
        <div className="relative flex w-full flex-col overflow-visible bg-white sm:flex-row">
          <ContentSlider
            elements={6}
            elementsInView={3}
            className="px-2 pt-4"
            showNext={"More tutorials"}
          >
            <div className="w-full flex-shrink-0 px-2 pb-6 md:w-1/3">
              <Video video="introduction_to_emma">
                <p className="mt-3">Set up your organization 1</p>
              </Video>
            </div>
            <div className="w-full flex-shrink-0 px-2 pb-6 md:w-1/3">
              <Video video="sign_up">
                <p className="mt-3">Start an accounting period 2</p>
              </Video>
            </div>
            <div className="w-full flex-shrink-0 px-2 pb-6 md:w-1/3">
              <Video video="introduction_to_emma">
                <p className="mt-3">Start an accounting period 3</p>
              </Video>
            </div>
            <div className="w-full flex-shrink-0 px-2 pb-6 md:w-1/3">
              <Video video="sign_up">
                <p className="mt-3">Set up your organization 4</p>
              </Video>
            </div>
            <div className="w-full flex-shrink-0 px-2 pb-6 md:w-1/3">
              <Video video="introduction_to_emma">
                <p className="mt-3">Start an accounting period 5</p>
              </Video>
            </div>
            <div className="w-full flex-shrink-0 px-2 pb-6 md:w-1/3">
              <Video video="sign_up">
                <p className="mt-3">Start an accounting period 6</p>
              </Video>
            </div>
          </ContentSlider>
        </div>
      </div>

      <Subheader className="mt-10">NEWS</Subheader>
      <LoadingProvider>
        <GidasFeed count="3" />
      </LoadingProvider>
    </div>
  );
}

General.layout = (page) => {
  const user = page?.props?.auth?.user?.data;
  return (
    <AppLayout>
      {/* <AdminLayout>{page}</AdminLayout> */}
      <OrganizationLayout
        header={`Welcome to Emma, ${user.firstname}`}
        icon={
          <LayoutIcon>
            <House size={40} className="text-black" />
          </LayoutIcon>
        }
        byline="Save time, get a daily overview of your emissions and improve accuracy with the Emma workflow"
      >
        {page}
      </OrganizationLayout>
    </AppLayout>
  );
};
